module.exports = __webpack_public_path__ + "static/media/omega-icon-for-real.1d5733bc.png";